import {EMPTY_FILTER} from './urls';

export const getAuctioneerName = auctioneerData => {
    let {
        firstName,
        lastName,
        company
    } = auctioneerData || {};

    return firstName && lastName ? `${firstName} ${lastName}`
        : firstName ? firstName
        : lastName ? lastName
        : company ? company
        : 'Auctioneer';
};

export const getDesignations = auctioneerData => {
    const {designations} = auctioneerData || {};

    return (
        designations && designations.length && designations.join
            ? designations.join(', ')
            : ''
    );
};

export const getAuctioneerLocation = (auctioneerData, includeZip) => {
    let {
        city,
        state,
        zip
    } = auctioneerData || {};

    return includeZip && city && state && zip ? `${city}, ${state} ${zip}`
        : includeZip && state && zip ? `${state} ${zip}`
        : includeZip && city && zip ? `${city} ${zip}`
        : city && state ? `${city}, ${state}`
        : city ? city
        : state ? state
        : null;
};

export const getFilterParamsFromMatch = (match) => {
    let {params} = match || {};
    let {page, expertise, search, association} = params || {};

    if (expertise === EMPTY_FILTER) {
        expertise = undefined;
    }
    if (search === EMPTY_FILTER) {
        search = undefined;
    }
    if (association === EMPTY_FILTER) {
        association = undefined;
    }

    return {page, expertise, search, association};
};
